const en = {
  "nav.home": "Home",
  "nav.services": "Client Services",
  "nav.services.website": "Website Creation",
  "nav.services.smm": "SMM / Social Media Marketing",
  "nav.services.traffic": "Traffic Packages / Digital Marketing",
  "nav.aiTools": "AI Tools Hub",
  "nav.aiTools.reviews": "AI Tool Reviews",
  "nav.aiTools.guides": "Guides & Tutorials",
  "nav.aiTools.landing": "Landing Pages / Offers",
  "nav.about": "About Us",
  "nav.profile": "Profile",
  "nav.portfolio": "Portfolio",
  "nav.contact": "Contact",
  "nav.getStarted": "Get Started",
  "nav.language": "Language",

  "hero.eyebrow": "Uganda\'s Premier Digital Agency",
  "hero.title1": "Transform Your",
  "hero.title2": "Digital Presence",
  "hero.title3": "With BientoMart",
  "hero.subtitle": "We build stunning websites, grow your social media, and connect you with the best AI tools to supercharge your business across East Africa.",
  "hero.cta1": "Explore Services",
  "hero.cta2": "View AI Tools",
  "hero.stat1.value": "30+",
  "hero.stat1.label": "Projects Delivered",
  "hero.stat2.value": "98%",
  "hero.stat2.label": "Client Satisfaction",
  "hero.stat3.value": "24/7",
  "hero.stat3.label": "Support Available",

  "services.label": "Our Services",
  "services.title": "Everything You Need to Succeed Online",
  "services.subtitle": "From stunning websites to powerful social media strategies, we deliver measurable results for Ugandan businesses and entrepreneurs.",
  "services.learnMore": "Learn More",
  "services.websiteTitle": "Website Creation",
  "services.websiteDesc": "Custom-built, SEO-optimized websites that convert visitors into paying customers.",
  "services.websiteFeature1": "Custom responsive design",
  "services.websiteFeature2": "SEO-optimized from day one",
  "services.websiteFeature3": "Fast loading & secure",
  "services.websiteFeature4": "Content management system",
  "services.websiteFrom": "Starting from $299",
  "services.smmTitle": "Social Media Marketing",
  "services.smmDesc": "Strategic social media management that builds your brand and grows your audience organically.",
  "services.smmFeature1": "Content creation & scheduling",
  "services.smmFeature2": "Audience engagement strategy",
  "services.smmFeature3": "Analytics & monthly reports",
  "services.smmFeature4": "Paid ads management",
  "services.smmFrom": "Starting from $150/mo",
  "services.trafficTitle": "Traffic & Digital Marketing",
  "services.trafficDesc": "Targeted campaigns that drive qualified traffic and boost your online revenue.",
  "services.trafficFeature1": "Google Ads campaigns",
  "services.trafficFeature2": "Facebook & Instagram Ads",
  "services.trafficFeature3": "SEO & keyword optimization",
  "services.trafficFeature4": "Conversion rate optimization",
  "services.trafficFrom": "Starting from $200/mo",

  "aiTools.label": "AI Tools Hub",
  "aiTools.title": "Discover Powerful AI Tools",
  "aiTools.subtitle": "Curated recommendations and honest reviews to supercharge your workflow and boost productivity.",
  "aiTools.readReview": "Read Full Review",
  "aiTools.rating": "Rating",
  "aiTools.tryNow": "Try It Now",
  "aiTools.textGenTitle": "Top AI Text Generator",
  "aiTools.textGenCategory": "Content Creation",
  "aiTools.textGenDesc": "Generate high-quality articles, copy, and marketing content in seconds with Jasper AI.",
  "aiTools.imageGenTitle": "AI Image Generator",
  "aiTools.imageGenCategory": "Visual Design",
  "aiTools.imageGenDesc": "Create stunning visuals, product images, and marketing graphics with Midjourney.",
  "aiTools.videoCreatorTitle": "AI Video Creator",
  "aiTools.videoCreatorCategory": "Video Production",
  "aiTools.videoCreatorDesc": "Transform scripts into professional videos in minutes with Pictory AI.",

  "about.label": "About BientoMart",
  "about.title": "Your Trusted Digital Partner in Uganda",
  "about.p1": "BientoMart is Uganda\'s leading digital services platform, helping businesses and entrepreneurs build powerful online presences since 2020.",
  "about.p2": "Our team of expert designers, marketers, and AI specialists works tirelessly to deliver exceptional results for clients across East Africa.",
  "about.p3": "We combine cutting-edge technology with deep local market knowledge to create digital strategies that truly resonate with Ugandan audiences.",
  "about.stat1.value": "5+",
  "about.stat1.label": "Years in Business",
  "about.stat2.value": "50+",
  "about.stat2.label": "Happy Clients",
  "about.stat3.value": "30+",
  "about.stat3.label": "Projects Completed",
  "about.cta": "Hire Us Today",

  "testimonials.label": "Client Success Stories",
  "testimonials.title": "What Our Clients Say",
  "testimonials.subtitle": "Real results from real businesses ",

  "contact.label": "Get in Touch",
  "contact.title": "Start Your Digital Journey Today",
  "contact.subtitle": "Ready to take your business to the next level? Let\'s talk about how BientoMart can help you succeed online.",
  "contact.name": "Full Name",
  "contact.email": "Email Address",
  "contact.phone": "Phone Number",
  "contact.service": "Service Interested In",
  "contact.message": "Your Message",
  "contact.send": "Send Message",
  "contact.sending": "Sending...",
  "contact.success": "Thank you! Your message has been sent. We\'ll be in touch within 24 hours.",
  "contact.error": "Something went wrong. Please try again.",
  "contact.address": "Kampala, Uganda",
  "contact.phoneValue": "+256 773515447",
  "contact.emailValue": "bientomart@gmail.com",
  "contact.hours": "Mon - Fri: 8:00 AM - 6:00 PM EAT",
  "contact.optWebsite": "Website Creation",
  "contact.optSMM": "Social Media Marketing",
  "contact.optTraffic": "Traffic Packages",
  "contact.optAI": "AI Tools Consultation",
  "contact.optOther": "Other",

  "footer.tagline": "Empowering Ugandan businesses through digital innovation and AI-powered solutions.",
  "footer.services": "Services",
  "footer.resources": "Resources",
  "footer.newsletter": "Stay Updated",
  "footer.newsletterDesc": "Get digital marketing tips and AI tool updates delivered to your inbox.",
  "footer.emailPlaceholder": "Your email address",
  "footer.subscribe": "Subscribe",
  "footer.copyright": "© 2026 BientoMart. All rights reserved.",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms of Service",
  "footer.blog": "Blog",
  "footer.caseStudies": "Case Studies",
  "footer.tutorials": "Tutorials",
  "footer.faq": "FAQ",
  "footer.websiteCreation": "Website Creation",
  "footer.smm": "Social Media Marketing",
  "footer.traffic": "Traffic Packages",
  "footer.aiReviews": "AI Tool Reviews",

  "svc.hiresTitle": "Hire Us for This Service",
  "svc.hiresSubtitle": "Ready to get started? Contact us today for a free consultation.",
  "svc.getQuote": "Get Yours Now",
  "svc.whatsapp": "Chat on WhatsApp",
  "svc.portfolioLabel": "Our Work",
  "svc.testimonialsLabel": "Client Testimonials",
  "svc.processLabel": "Our Process",
  "svc.pricingLabel": "Pricing Plans",
  "svc.basic": "Basic",
  "svc.standard": "Standard",
  "svc.premium": "Premium",
  "svc.popular": "Most Popular",
  "svc.perMonth": "/ month",
  "svc.oneTime": "one-time",
  "svc.chooseplan": "Choose Plan",

  "review.overview": "Quick Overview",
  "review.features": "Key Features",
  "review.guide": "Step-by-Step Guide",
  "review.pricing": "Pricing",
  "review.verdict": "Final Verdict",
  "review.pros": "Pros",
  "review.cons": "Cons",
  "review.tryAffiliate": "Try It Free",
  "review.getStarted": "Get Started with",
  "review.bestFor": "Best For",
  "review.ourRating": "Our Rating",
  "review.freeTrialAvail": "Free Trial Available",
  "review.yes": "Yes",

  "profile.title": "About BientoMart",
  "profile.subtitle": "Your trusted digital partner in Uganda",
  "profile.aboutTitle": "Empowering Businesses Through Digital Innovation",
  "profile.aboutP1": "BientoMart is Uganda's leading digital services platform, helping businesses and entrepreneurs build powerful online presences since 2020.",
  "profile.aboutP2": "Our team of expert designers, marketers, and AI specialists works tirelessly to deliver exceptional results for clients across East Africa.",
  "profile.aboutP3": "We combine cutting-edge technology with deep local market knowledge to create digital strategies that truly resonate with Ugandan audiences.",
  "profile.cta": "Get in Touch",
  "profile.valuesTitle": "Our Core Values",
  "profile.valuesSubtitle": "The principles that guide everything we do",
  "profile.teamTitle": "Meet Our Team",
  "profile.teamSubtitle": "The passionate people behind BientoMart",
  "profile.whyTitle": "Why Choose BientoMart",
  "profile.whySubtitle": "What sets us apart from the rest",
  "profile.why1Title": "Fast Delivery",
  "profile.why1Desc": "We deliver projects on time, every time. No delays, no excuses.",
  "profile.why2Title": "Affordable Pricing",
  "profile.why2Desc": "Competitive rates tailored to Ugandan businesses and budgets.",
  "profile.why3Title": "24/7 Support",
  "profile.why3Desc": "Round-the-clock support to ensure your business never stops.",
  "profile.ctaTitle": "Ready to Transform Your Business?",
  "profile.ctaSubtitle": "Let's create something amazing together. Contact us today to discuss your project",
  "profile.ctaButton": "Get Started",
  "profile.callUs": "Call Us",

  "founder.label": "Meet the Founder",
  "founder.title": "Bienvenu Masengesho",
  "founder.subtitle": "Founder & CEO of BientoMart",
  "founder.cta": "Work With Me",
  "founder.viewProfile": "View Full Profile",
  "founder.expertise": "Areas of Expertise",
  "founder.aiIT": "AI & IT",
  "founder.softwareDev": "Software Development",
  "founder.webDev": "Website Development",
  "founder.digitalMarketing": "Digital Marketing",
  "founder.businessAutomation": "Business Automation",
  "founder.consulting": "IT Consulting",
  "founder.projects": "Selected Projects",
  "founder.articles": "Articles & Insights",
  "founder.article1": "AI for Ugandan Businesses",
  "founder.article2": "Digital Transformation for SMEs",
  "founder.article3": "Website Development Best Practices",
  "founder.article4": "AI Automation for Local Enterprises",
  "founder.article5": "Software Development in East Africa",
  "founder.article6": "The Future of AI in East Africa",
  "founder.article7": "Construction Management Software",
  "founder.readMore": "Read Article",
  "founder.socialLinks": "Connect With Me",
  "founder.consultationCta": "Book a Consultation",
  "founder.consultationSubtitle": "Let's discuss how AI and digital solutions can grow your business.",
  "founder.whatsapp": "Chat on WhatsApp",
  "founder.heroBio": "Founder & CEO of BientoMart, driving digital innovation across Uganda and East Africa through AI, software development, and strategic marketing.",

  "portfolio.title": "Our Portfolio",
  "portfolio.subtitle": "Explore our successful projects and see how we have helped businesses achieve their digital goals",
  "portfolio.projectsCompleted": "Projects Completed",
  "portfolio.happyClients": "Happy Clients",
  "portfolio.yearsExperience": "Years Experience",
  "portfolio.clientSatisfaction": "Client Satisfaction",
  "portfolio.visitProject": "Visit the Project",
  "portfolio.industriesTitle": "Industries We Serve",
  "portfolio.industriesSubtitle": "Our expertise spans across multiple industries, delivering tailored solutions for each sector",
  "portfolio.ctaTitle": "Ready to Start Your Project?",
  "portfolio.ctaSubtitle": "Let's create something amazing together. Contact us today to discuss your project",
  "portfolio.startProject": "Start Your Project",
  "portfolio.viewServices": "View Our Services",
};

export default en;
